import { render, staticRenderFns } from "./CardConvocatoria.vue?vue&type=template&id=812d91ba&scoped=true"
import script from "./CardConvocatoria.vue?vue&type=script&lang=js"
export * from "./CardConvocatoria.vue?vue&type=script&lang=js"
import style0 from "./CardConvocatoria.vue?vue&type=style&index=0&id=812d91ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812d91ba",
  null
  
)

export default component.exports